import React, { useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";

const ForgotPassword = () => {
  const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v3`;
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {
    handleSubmit,
    control,
    register,
    formState: { errors, isValid, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      identifier: "",
    },
  });

  const onSubmit = async ({ identifier }) => {
    setErrorMessage("");
    try {
      await fetch(`${apiBaseUrl}/auth/password-reset/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ identifier }),
      });
      setSubmitted(true);
    } catch (error) {
      setSubmitted(true);
      setErrorMessage("We could not process your request right now. Please try again.");
    }
  };

  return (
    <section>
      <Container maxWidth="sm">
        <Box pt={8} pb={10}>
          <Box mb={6} textAlign="center">
            <Typography variant="h4" component="h2" gutterBottom>
              Forgot Password
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" paragraph>
              Enter your email or username and we&apos;ll send you a reset link if an account exists.
            </Typography>
          </Box>

          {submitted ? (
            <Box textAlign="center">
              <Typography variant="h6" gutterBottom>
                If an account exists for that identifier, we sent a password reset link.
              </Typography>
              <Typography color="textSecondary">
                Please check your email for further instructions.
              </Typography>
              {errorMessage && (
                <Box mt={2}>
                  <Typography color="error">{errorMessage}</Typography>
                </Box>
              )}
            </Box>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Controller
                name="identifier"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    type="text"
                    variant="outlined"
                    required
                    fullWidth
                    onChange={onChange}
                    value={value}
                    id="identifier"
                    label="Email or Username"
                    placeholder="you@example.com"
                    autoComplete="username"
                    error={!!errors.identifier}
                    helperText={errors.identifier && "Please enter your email or username"}
                  />
                )}
                {...register("identifier", { required: true })}
                ref={null}
              />
              <Box my={2}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={!isValid || isSubmitting}
                >
                  Send reset link
                </Button>
              </Box>
              {errorMessage && (
                <Typography color="error" align="center">
                  {errorMessage}
                </Typography>
              )}
            </form>
          )}
        </Box>
      </Container>
    </section>
  );
};

export default ForgotPassword;
